import React from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router';
import styles from 'styles';
import { types as TYPES_BY_PURPOSE } from 'constants/vesselTypes';
import TypeBySpecialty from '../Single/Rows/TypeBySpecialty';
import { CenterBox } from './utils';

const getDate = (type) => {
    const date = new Date();
    switch (type) {
    case 'week': date.setDate(date.getDate() - 7); return date;
    case 'month': date.setMonth(date.getMonth() - 1); return date;
    case 'year': date.setFullYear(date.getFullYear() - 1); return date;
    default: return date;
    }
};

const exclusionsAndRestrictions = [
    { date: null, label: 'Any' },
    { date: getDate('week'), label: 'Last Week' },
    { date: getDate('month'), label: 'Last Month' },
    { date: getDate('year'), label: 'Last Year' },
];

const filterRowStyle = {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: 16,
    width: '70%',
};

const selectStyle = {
    width: 150,
    textAlign: 'left',
    fontSize: '13px',
};

const labelStyle = {
    left: '0',
    fontSize: '13px',
};

const numberInputStyle = {
    width: 90,
    fontSize: '13px',
};

const checkboxStyle = {
    display: 'inline-block',
    width: 'auto',
    whiteSpace: 'nowrap',
};

const checkboxLabelStyle = {
    fontSize: '13px',
};

export default function VesselsListFilters({
    searchRef,
    defaultSearchValue,
    clearSearch,
    handleSearch,
    isNameSuggestion,
    notConfirmed,
    handleNameSuggested,
    handleConfirmed,
    modifiedFilter,
    handleFilters,
    filterCargoExclusions,
    filterTradingRestrictions,
    handleExclusions,
    photosFilter,
    sanctioned,
    handleSanctioned,
    rightPart,
    typeByPurpose,
    typeBySpecialty,
    dwtMin,
    dwtMax,
    bltMin,
    bltMax,
    sortValue,
    sortField,
}) {
    return (
        <React.Fragment>
            <div className='table-header'>
                <div className='item' style={{ width: '60%' }}>
                    <div style={{
                        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12, 
                    }}
                    >
                        <TextField
                            defaultValue={defaultSearchValue}
                            floatingLabelText='Search by IMO or name'
                            ref={searchRef}
                            style={{ width: 200 }}
                            onChange={clearSearch}
                            onKeyPress={(event) => {
                                if (event.charCode === 13) {
                                    event.preventDefault();
                                    handleSearch();
                                }
                            }}
                        />
                        <RaisedButton
                            label='Search'
                            style={styles.RaisedButton}
                            primary
                            onClick={handleSearch}
                        />

                        <span style={{ borderLeft: '1px solid #ccc', height: 28, margin: '0 4px' }} />

                        <Checkbox
                            label='Not confirmed'
                            checked={notConfirmed}
                            onCheck={handleConfirmed}
                            style={checkboxStyle}
                            labelStyle={checkboxLabelStyle}
                        />
                        <Checkbox
                            label='Rename suggestion'
                            checked={isNameSuggestion}
                            onCheck={handleNameSuggested}
                            style={checkboxStyle}
                            labelStyle={checkboxLabelStyle}
                        />
                        <Checkbox
                            label='Sanctioned'
                            checked={sanctioned}
                            onCheck={handleSanctioned}
                            style={checkboxStyle}
                            labelStyle={checkboxLabelStyle}
                        />
                    </div>
                </div>
                <div className='item' style={{ width: '40%' }}>
                    {rightPart}
                </div>
            </div>

            <div className='table-header'>
                <div className='item' style={filterRowStyle}>
                    <SelectField
                        floatingLabelText='Type by purpose'
                        floatingLabelStyle={labelStyle}
                        value={typeByPurpose || ''}
                        onChange={(_e, _i, val) => handleFilters('typeByPurpose', val || '')}
                        style={selectStyle}
                    >
                        <MenuItem value='' primaryText='' />
                        {TYPES_BY_PURPOSE.map(tp => (
                            <MenuItem key={tp} value={tp} primaryText={tp} />
                        ))}
                    </SelectField>

                    <TypeBySpecialty 
                        typeBySpecialty={typeBySpecialty || ''}
                        fromTcOrder={false}
                        
                        style={selectStyle}
                        changeField={(vals) => {
                            const v = vals.find(val => val.field === 'typeBySpecialty').value;
                            return handleFilters(
                                'typeBySpecialty', 
                                v === '' ? undefined : v,
                            );
                        }
                        }
                        typeByPurpose={typeByPurpose}
                        withoutSpecialtyEnabled
                    />

                    <span style={{ borderLeft: '1px solid #ccc', height: 28, margin: '0 4px' }} />

                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                        <TextField
                            floatingLabelText='DWT min'
                            type='number'
                            value={dwtMin || ''}
                            onChange={(_e, v) => handleFilters('dwtMin', v === '' ? null : Number(v))}
                            style={numberInputStyle}
                        />
                        <span style={{ paddingBottom: 10, color: '#888' }}>–</span>
                        <TextField
                            floatingLabelText='DWT max'
                            type='number'
                            value={dwtMax || ''}
                            onChange={(_e, v) => handleFilters('dwtMax', v === '' ? null : Number(v))}
                            style={numberInputStyle}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                        <TextField
                            floatingLabelText='BLT min'
                            type='number'
                            value={bltMin || ''}
                            onChange={(_e, v) => handleFilters('bltMin', v === '' ? null : Number(v))}
                            style={numberInputStyle}
                        />
                        <span style={{ paddingBottom: 10, color: '#888' }}>–</span>
                        <TextField
                            floatingLabelText='BLT max'
                            type='number'
                            value={bltMax || ''}
                            onChange={(_e, v) => handleFilters('bltMax', v === '' ? null : Number(v))}
                            style={numberInputStyle}
                        />
                    </div>

                    <SelectField
                        floatingLabelText='Sort by BLT'
                        floatingLabelStyle={labelStyle}
                        value={sortField === 'blt' ? sortValue : null}
                        onChange={(_e, _i, val) => {
                            const isBlank = val == null;
                            handleFilters({
                                sortField: isBlank ? undefined : 'blt',
                                sortValue: isBlank ? undefined : val,
                            });
                        }}
                        style={{ ...selectStyle, width: 130 }}
                    >
                        <MenuItem value={null} primaryText='' />
                        <MenuItem value={-1} primaryText='Newest first' />
                        <MenuItem value={1} primaryText='Oldest first' />
                    </SelectField>
                </div>
                <div className='item'>
                    <CenterBox>
                        <RaisedButton
                            label="ADD NEW VESSEL"
                            style={styles.RaisedButton}
                            primary
                            containerElement={<Link to="/vessels/add" />}
                        />
                    </CenterBox>
                </div>
            </div>

            <div className='table-header'>
                <div className='item' style={filterRowStyle}>
                    <SelectField
                        floatingLabelText='Modified'
                        floatingLabelStyle={labelStyle}
                        value={modifiedFilter}
                        onChange={(_ev, _idx, val) => handleFilters('modifiedFilter', val)}
                        style={selectStyle}
                    >
                        <MenuItem value='all' primaryText='All' />
                        <MenuItem value='modified' primaryText='Modified' />
                        <MenuItem value='notModified' primaryText='Not modified' />
                    </SelectField>

                    <SelectField
                        floatingLabelText='Photos'
                        floatingLabelStyle={labelStyle}
                        value={photosFilter}
                        onChange={(_ev, _idx, val) => handleFilters('photosFilter', val)}
                        style={selectStyle}
                    >
                        <MenuItem value='all' primaryText='All' />
                        <MenuItem value='withPhotos' primaryText='With photos' />
                        <MenuItem value='withoutPhotos' primaryText='Without photos' />
                    </SelectField>

                    <span style={{ borderLeft: '1px solid #ccc', height: 28, margin: '0 4px' }} />

                    <SelectField
                        floatingLabelText='Cargo exclusions'
                        floatingLabelStyle={labelStyle}
                        value={filterCargoExclusions}
                        onChange={(_ev, _idx, val) => handleExclusions(val, 'filterCargoExclusions')}
                        style={{ ...selectStyle, width: 160 }}
                    >
                        {exclusionsAndRestrictions.map((excl, idx) => (
                            <MenuItem
                                key={idx}
                                value={excl.date ? excl.date.toISOString() : null}
                                primaryText={excl.label}
                            />
                        ))}
                    </SelectField>

                    <SelectField
                        floatingLabelText='Trading restrictions'
                        floatingLabelStyle={labelStyle}
                        value={filterTradingRestrictions}
                        onChange={(_ev, _idx, val) => handleExclusions(val, 'filterTradingRestrictions')}
                        style={{ ...selectStyle, width: 170 }}
                    >
                        {exclusionsAndRestrictions.map((excl, idx) => (
                            <MenuItem
                                key={idx}
                                value={excl.date ? excl.date.toISOString() : null}
                                primaryText={excl.label}
                            />
                        ))}
                    </SelectField>
                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Filters.jsx